import { Modal } from '@lib/components'
import type React from 'react'

import type { ModalProps } from '@/types'
import { Field, Logos } from './components'
import css from './styles.module.css'

export const ExportAsPrompt: React.FC<ModalProps> = ({ onClose, onBack }) => (
  <Modal width={640} onClose={onClose} onBack={onBack}>
    <div className={css.content}>
      <div className={css.content_top}>
        <Logos />

        <div className={css.content_text_wrap}>
          <div className={css.title}>Export to AI website builders</div>
          <div className={css.description}>
            Just paste this prompt in your preferred website <br /> generation
            tool.
          </div>
        </div>
      </div>

      <Field />
    </div>
  </Modal>
)
